import { Capacitor } from '@capacitor/core';

/** Native Capacitor app on iPhone or iPad (App Store build). */
export const isNativeIOSApp = (): boolean =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
